export default __webpack_public_path__ + "static/media/decada-0070-0007-min.a9529337.jpg";